import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorMessages } from '../error/custom-error-messages';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error && typeof error.error === 'string') {
          try {
            let message: string = '';
            const errorCode = error?.error || error;
            if (errorCode && ErrorMessages[errorCode as keyof typeof ErrorMessages]) {
              message = ErrorMessages[errorCode as keyof typeof ErrorMessages];
            } else if (error?.message) {
              message = error.message;
            } else {
              message = $localize `:Unexpected error | Generic error message when an unknown error occurs.@@genericUnexpectedError:Ocurrió un error inesperado`;;
            }
            // const parsedError = JSON.parse(message);
            const newError = new HttpErrorResponse({
              error: message,
              headers: error.headers,
              status: error.status,
              statusText: error.statusText,
              url: error.url ?? undefined, 
            });
            error = newError;
          } catch {
            // Si no es JSON, lo deja como está
          }
        }
        // this.errorHandler.handleError(error);
        return throwError(() => error);
      })
    );
  }
}
